<div class="row">

    <div class="col-12">

        <div class="card filter">

            <div class="card-body">

                <div class="filter">

                    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="department"> {{ 'EMPLOEE.DEPARTMENT' | translate }}</label>
                                    <ng-select id="department" class="custom" clearAllText="{{ 'CLEAN' | translate }}"
                                        notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="name" bindValue="id"
                                        formControlName="department_id" [loading]="loading" [items]="departments">
                                    </ng-select>
                                </div>
                            </div>

                            <div class="col-6">

                                <div class="form-group">
                                    <label for="position"> {{ 'EMPLOEE.POSITION' | translate }}</label>
                                    <ng-select id="position" class="custom" clearAllText="{{ 'CLEAN' | translate }}"
                                        notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="name" bindValue="id"
                                        formControlName="position_id"
                                        [loading]="loading" [items]="positions">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</div>




<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'ORGANIZATION.STRUCTURAL_ORGANIZATION' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>
            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="department">{{ 'EMPLOEE.DEPARTMENT' | translate }}</th>
                            <th scope="col" class="position">{{ 'EMPLOEE.POSITION' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="structures.length > 0">

                        <tr *ngFor="let structure of structures">

                            <td class="department">{{ structure.department.name }}</td>
                            <td class="position">{{ structure.position.name}}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" (click)="onConfirm([structure.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="structures.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="6">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="6">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>